import { Container, Mesh, MeshGeometry, type Texture } from "pixi.js";
import type { Vector } from "@common/utils/vector";
import { paintedShoreGeometry, type PaintedShoreSource } from "./paintedShoreGeometry";

/** Two static textured meshes for the entire map. The artwork includes foam, leaves, wet sand and shadows. */
export class PaintedShore {
    readonly container = new Container({ label: "painted shore", zIndex: 1 });
    readonly meshes: Mesh[] = [];

    constructor(turf: Texture, surf: Texture, grass: readonly PaintedShoreSource[], water: readonly PaintedShoreSource[],
        scale: number, waterAt?: (point: Vector) => boolean, sandAt?: (point: Vector) => boolean) {
        for (const [texture, sources, isWater] of [[turf, grass, false], [surf, water, true]] as const) {
            const data = paintedShoreGeometry(sources, scale, isWater, waterAt, sandAt);
            if (!data.indices.length) continue;
            const geometry = new MeshGeometry(data);
            geometry.batchMode = "no-batch";
            const mesh = new Mesh({ geometry, texture, label: isWater ? "painted surf" : "painted turf" });
            this.container.addChild(mesh);
            this.meshes.push(mesh);
        }
    }

    destroy(): void {
        for (const mesh of this.meshes) mesh.geometry.destroy();
        this.container.destroy({ children: true, texture: false, textureSource: false });
        this.meshes.length = 0;
    }
}
